// Images de carte des pages d'un ordre ou de l'OPLAN, servies par `/api/exercises/{id}/order/{nom}.jpg` et
// recalculées sur l'état du dossier : A4 (ZEF et ZEA) et C7 (pénétrantes et rocades) de la division, annexes B
// et D du corps, schéma de manœuvre de l'annexe A de l'OPLAN (absent jusqu'au 24/10/2026 : la page de la carte
// de l'aperçu de l'OPLAN restait vide, registre A100).
export const MAP_IMAGES: ReadonlySet<string> = new Set([
  "fires-map",
  "logistics-map",
  "corps-fires-map",
  "corps-air-map",
  "oplan-scheme-map",
]);

/** Adresse des images d'une page d'ordre mise en page (logo, signature, cartes d'annexe) : les cartes suivent la
 *  version de l'ordre et celle du dossier. Partagée par la vue de l'ordre et l'aperçu de la déclinaison (qui ne
 *  chargeait aucune carte d'annexe jusqu'au 24/10/2026). `language` : langue de lecture de l'ordre (bascule de
 *  langue, docs/13) — la carte est redessinée dans la langue du poste, l'adresse change avec elle. */
export function orderImageUrl(
  base: string,
  number: number,
  orderVersion: number | string,
  exerciseVersion: number | string,
  language?: string,
): (name: string) => string | null {
  const q = `number=${number}`;
  return (name: string) =>
    name === "logo" || name.endsWith("_Logo")
      ? `${base}/logo.png?${q}`
      : name === "signature"
        ? `${base}/signature.png?${q}&v=${orderVersion}`
        : MAP_IMAGES.has(name)
          ? `${base}/${name}.jpg?${q}&v=${orderVersion}.${exerciseVersion}${language ? `&lang=${language}` : ""}`
          : null;
}
